import React, { useState } from 'react';
import './App.css';
import AdUnit from "./AdUnit";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FaYoutube, FaInstagram } from "react-icons/fa";
import AboutSection from "./AboutSection";
import FeatureSection from './FeatureSection';
import OrganiserTeamSection from './OrganiserTeamSection';
import FaqSection from './FaqSection';
import { Link } from "react-router-dom";

const apiUrl = process.env.REACT_APP_API_URL;
const apiKey = process.env.REACT_APP_API_KEY;
const App = () => {

  const [isSignedIn, setIsSignedIn] = useState(false);
  const [isSignInClicked, setIsSignInClicked] = useState(false);
  const [organizer, setOrganizer] = useState({ name: '', email: '', password: '', role: '', confirmPassword: '' });
  const [tournament, setTournament] = useState({ name: '', date: '', endDate: '', location: '', area: '', privateTournament: false, sportName:'', creator: '', contactNo: '', venue: '' });
  const [userTournaments, setUserTournaments] = useState([]);
  const [showTournamentModal, setShowTournamentModal] = useState(false);
  const [showTeamModal, setShowTeamModal] = useState(false);
  const [showTeamPlayerModal, setShowTeamPlayerModal] = useState(false);
  const [showFixturesModal, setShowFixturesModal] = useState(false);
  const [viewFixturesModal, setViewFixturesModal] = useState(false);
  const [updateStatusModal, setUpdateStatusModal] = useState(false);
  const [leaderDashboardModal, setLeaderDashboardModal] = useState(false);
  const [showAdminTeamPlayer, setShowAdminTeamPlayer] = useState(false);
  const [showCertDownload, setShowCertDownload] = useState(false);
  const [forgotPasswordtatusModal, setforgotPasswordtatusModal] = useState(false);
  const [newTeam, setNewTeam] = useState({ name: '', tournamentId: '' , contactNo: ''});
  const [newFixture, setNewFixture] = useState({ tournamentId: '', teamA: '', teamB: '', ownFixture: '', startDate: '', stage: '', tournamentType: '', matchesPerDay: '', intervalHours: ''});
  const [viewFixture, setViewFixture] = useState({ tournamentId: '', matchId: '', teamA: '', teamB: '', matchStatus: '', winner: ''});
  const [leaderDashboard, setLeaderDashboard] = useState({ tournamentId: ''});
  const [updateStatus, setUpdateStatus] = useState({ tournamentId: '', fixtureId: '', matchStatus: '', winner: '', scoreCard: '', playerOfTheMatch: ''});

  const [managePlayerStats, setManagePlayerStats] = useState({ tournamentId: '', teamId: '', teamPlayerId: '', playerScore: ''});
  const [passwordReset, setPasswordReset] = useState({  emailId: '', password: '', confirmPassword: '', notificationType: '' });

  const [certRequest, setCertRequest] = useState({  name: '', tournamentId: '', award: '' });

  const [newTeamPlayer, setNewTeamPlayer] = useState({ name: '', tournamentId: '', teamId: '' });
  // Modal and team state for tournament details
  const [selectedTournament, setSelectedTournament] = useState(null);
  const [tournamentTeams, setTournamentTeams] = useState([]);
  const [teamDetails, setTeamDetails] = useState([]);
  const [showTeamDetailsModal, setShowTeamDetailsModal] = useState(false);
  const [listFixturesModal, setListFixturesModal] = useState(false);
  const [listLeaderModal, setListLeaderModal] = useState(false);

  const [listLeadersData, setListLeadersData] = useState([]);
  const [teamPlayerStatDetails, setTeamPlayerStatDetails] = useState(null);

  // Cities state
  const [cities, setCities] = useState([]);
  const [allFixtures, setAllFixtures] = useState([]);
  const MATCH_STATUS = {
    Completed : "Completed",
    Drawn: "Drawn",
    Cancelled: "Cancelled",
  };
  const [sports, setSports] = useState([]);
  // All tournaments state (for main page)
  const [allTournaments, setAllTournaments] = useState([]);
  // Rotating banner state
  const rotatingMessages = [
    "⚽ Register your tournament today!",
    "🏏 Build your dream team!",
    "🏸 Join the local sports movement!",
    "🥇 Compete • Connect • Celebrate!",
    "🥇 Bring your league to the world — fast and simple!",
  ];
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
  const [num1, setNum1] = useState('');
  const [num2, setNum2] = useState('');
  const [captchaInput, setCaptchaInput] = useState('');
  const [captchaValidation, setCaptchaValidation] = useState(false);


// Handle refresh
  // React.useEffect(() => {
  //   const handleRefresh = async () => {
  //     const token = localStorage.getItem('token');
  //     if (isSignedIn && token) {
  //     try {
  //       const response = await fetch(`${apiUrl}/refresh`, {
  //         method: 'POST',
  //         headers: { 'Content-Type': 'application/json', 'Authorization':  `Bearer ${token}`},
  //       });
  //       if (response.ok) {
  //         const result = await response.json();
  //         const jsonString =  JSON.stringify(result)
  //         const parsedObject = JSON.parse(jsonString);
  //         setIsSignedIn(true);
  //         setOrganizer({ ...organizer, name: parsedObject.name, role: parsedObject.role === 'Admin'});
  //         localStorage.setItem('token', parsedObject.token); 
  //       } else {
  //         const msg = await response.text();
  //         toast.error(msg || 'Authentication failed.');
  //         setIsSignedIn(false);
  //       }
  //     } catch (error) {
  //       console.error('Please try again later:', error);
  //       setIsSignedIn(false);
  //     }
  //   }
  //   };
  //   handleRefresh();
  // }, [isSignedIn]);



  // State to track modal position
const [toastMessage, setToastMessage] = useState("");

const showErrorToast = (message) => {
  setToastMessage(message);
  // auto hide toast after 3 seconds
  setTimeout(() => setToastMessage(""), 4000);
};

  // Fetch cities and all tournaments on component mount

  React.useEffect(() => {

    const fetchCities = async () => {
      if (isSignedIn) {
      try {
        const token = localStorage.getItem('token');
        const res = await fetch(`${apiUrl}/cities`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        const data = await res.json();
        setCities(data);
      } catch (err) {
        console.error('Failed to load cities:', err);
      }
    }
    };
    fetchCities();
    // Fetch all tournaments for display on main page
    const fetchAllTournaments = async () => {
      // const lat = 0
      // const lon = 0
      // navigator.geolocation.getCurrentPosition(
      //   (position) => {
      //   lat = position.coords.latitude;
      //   lon = position.coords.longitude;
      //   },
      //   (error) => {
      //     console.info('Location disabled:', error);
      //   }
      // );
      try {
        const res = await fetch(`${apiUrl}/public-tournaments`,  {
          headers: {
            'API_KEY': `${apiKey}`
          //  'X-User-Latitude': lat,
          //'X-User-Longitude': lon,
          }
        });
        const data = await res.json();
        setAllTournaments(data);
      } catch (err) {
        console.error('Failed to load tournaments:', err);
      }
    };
    fetchAllTournaments();
    // Fetch all sport names for display on main page
    const fetchAllSports = async () => {
      if (isSignedIn) {
      try {
        const token = localStorage.getItem('token');
        const res = await fetch(`${apiUrl}/sports`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        const data = await res.json();
        setSports(data);
      } catch (err) {
        console.error('Failed to load sports:', err);
      }
    }
    };
    fetchAllSports();
  }, [isSignedIn]);
  // Rotating banner effect
  React.useEffect(() => {
    const interval = setInterval(() => {
      setCurrentMessageIndex((prevIndex) => (prevIndex + 1) % rotatingMessages.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  React.useEffect(() => {
    const a = Math.floor(Math.random() * 10);
    const b = Math.floor(Math.random() * 10);
    setNum1(a);
    setNum2(b);
  }, []);


  // React.useEffect(() => {
  //   const timer = setTimeout(() => {
  //     localStorage.removeItem("token");
  //     window.location.href = "/";
  //   }, 30 * 60 * 1000); // 23 mins
  //   return () => clearTimeout(timer);
  // }, []);


  const handleCaptchaValidate = () => {
    if (parseInt(captchaInput, 10) === num1 + num2) {
    setCaptchaValidation(true)
    } else {
      setCaptchaValidation(false)
      toast.error('❌ Incorrect answer. Try again.');
    }
  };

  // Handler to open tournament modal and fetch teams
  const handleViewTournament = async (tournament) => {
    setSelectedTournament(tournament);
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${apiUrl}/teams?tournamentId=${tournament.id}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const data = await res.json();
      setTournamentTeams(data);
    } catch (err) {
      toast.error('Failed to load teams');
    }
  };


  

  const handleViewTournaments = async (tournamentId) => {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${apiUrl}/teams?tournamentId=${tournamentId}`,  {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const data = await res.json();
      setTournamentTeams(data);
    } catch (err) {
      toast.error('Failed to load teams');
    }
  };

  const handleViewFixturesForStatus = async (tournamentId) => {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${apiUrl}/fixture?tournamentId=${tournamentId}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const data = await res.json();
      setAllFixtures(data);

    } catch (err) {
      toast.error('Failed to load fixtures');
    }
  };


  const handleViewTeamDeatils = async (teamId) => {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${apiUrl}/team-details?teamId=${teamId}`,  {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const data = await res.json();
      setTeamDetails(data);
      setShowTeamDetailsModal(true)
      setSelectedTournament(null)
    } catch (err) {
      toast.error('Failed to load team details');
    }
  };




  const handleTeamPlayerStatsChange = async (tournamentId) => {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${apiUrl}/team-stats?tournamentId=${tournamentId}`,  {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const data = await res.json();
      setTeamPlayerStatDetails(data)
    } catch (err) {
      setManagePlayerStats({ ...managePlayerStats, tournamentId: '', teamId: '', teamPlayerId: '', playerScore: ''})
      toast.error('Failed to load team player stats');
    }
  };

  // Support login/registration toggle
  const [isRegisteredUserLogin, setIsRegisteredUserLogin] = useState(true);
  const handleSignIn = async (e) => {
    e.preventDefault();
    const url = isRegisteredUserLogin
      ? `${apiUrl}/login`
      : `${apiUrl}/signup`;

    try {
      if (!isRegisteredUserLogin && organizer.password !== organizer.confirmPassword){
        toast.error("Password and Confirm Password do not match")
        return
      }
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(organizer),
      });

      if (res.ok) {
        const result = await res.json();
        const jsonString =  JSON.stringify(result)
        const parsedObject = JSON.parse(jsonString);
        toast.success(`Welcome, ${parsedObject.name || parsedObject.email}!`);
        setIsSignedIn(true);
        setOrganizer({ ...organizer, name: parsedObject.name, role: parsedObject.role === 'Admin'});

        localStorage.setItem('token', parsedObject.token); 
      } else {
        const msg = await res.text();
        toast.error(msg || 'Authentication failed.');
      }
    } catch (err) {
      toast.error('Failed to connect to server.');
      console.error(err);
    }
  };

  React.useEffect(() => {
    const fetchUserTournaments = async () => {
      if (!isSignedIn || !organizer.email) return;
      try {
        const token = localStorage.getItem('token');

        const response = await fetch(`${apiUrl}/alltournaments`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Authorization':  `Bearer ${token}`},
          body: JSON.stringify({ ...organizer, email: organizer.email }),
        });
        const data = await response.json();
        setUserTournaments(data);
      } catch (error) {
        console.error('Error fetching user tournaments:', error);
      }
    };

    fetchUserTournaments();
  }, [isSignedIn, organizer.name]);


  return (
    <div className="min-h-screen flex flex-col bg-blue-50 text-black w-full">
  
  <header className="text-sm text-white py-4 sm:py-6 bg-blue-900 shadow-md">
  <div className="max-w-6xl mx-auto px-4 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 sm:gap-0">
    
    {/* 🔹 Left: Logo + Tagline */}
    <div className="flex flex-col items-center sm:items-start">
      <div className="flex items-center gap-2">
        <img
          src="/image1.png"
          alt="Logo"
          className="h-12 w-12 sm:h-16 sm:w-16 rounded-full shadow"
        />
        <h1 className="text-xl sm:text-2xl font-bold italic whitespace-nowrap">
          <span className="text-white">League</span>
          <span className="text-red-500">Sphere</span>
        </h1>
      </div>
      <span className="text-purple-200 italic text-xs sm:text-sm">
        Plan. Promote. Play
      </span>
    </div>

    {/* 🔹 Center: Nav */}
    <nav className="flex flex-row justify-center items-center gap-2 sm:gap-4 font-medium text-sm sm:text-base">
  <Link
    to="/about-leaguesphere"
    className="px-2 py-1 rounded-md hover:bg-blue-800 hover:text-white transition"
  >
    About
  </Link>
  <Link
    to="/feature"
    className="px-2 py-1 rounded-md hover:bg-blue-800 hover:text-white transition"
  >
    Features
  </Link>
  <Link
    to="/booking"
    className="px-2 py-1 rounded-md hover:bg-blue-800 hover:text-white transition"
  >
    Book Playground Nearby
  </Link>
</nav>

    {/* 🔹 Right: Auth buttons */}
    <div className="flex justify-center sm:justify-end gap-3">
      {!isSignedIn ? (
        
         <button
         onClick={() => setIsSignInClicked(prev => !prev)}

          className="bg-blue-600 hover:bg-blue-700 text-white text-xs sm:text-sm font-medium py-2 px-4 rounded shadow"
        >
          Login / Register
        </button>
      ) : (
        <button
          onClick={() => {
            setIsSignedIn(false);
            setIsSignInClicked(false)
            setOrganizer({ name: "", email: "", password: "" });
            setTournament({
              name: "",
              date: "",
              endDate: "",
              location: "",
              area: "",
              sportName: "",
            });
            localStorage.setItem("token", "");
            setIsRegisteredUserLogin(true);
            toast.info("Logged out successfully.");
          }}
          className="bg-red-600 hover:bg-blue-700 text-white text-xs sm:text-sm font-medium py-2 px-4 rounded shadow"
        >
          Log Out
        </button>
      )}
    </div>
  </div>
</header>
  
{/* Hero Section */}
<section className="bg-gradient-to-r from-blue-50 via-blue-200 to-blue-200 rounded-xl shadow-lg text-center p-4 sm:p-6">
        <p className="font-medium italic text-base sm:text-lg md:text-xl mb-6">
          Your <span className="text-indigo-600 font-bold">hub</span> for discovering, organizing, and promoting
          <span className="text-red-500 font-semibold"> local sports tournaments</span> — connecting players, teams, and fans across your city!
        </p>
        <div className="flex flex-col md:flex-row items-center justify-center gap-3">
          {!isSignedIn && (
            <p className="text-black font-medium italic text-lg md:text-xl text-center md:text-left">
              Where every <span className="text-indigo-700">match</span> begins. Your Arena. Your Rules. Our Platform!
            </p>
          )}
          <div className="flex gap-2 text-2xl">
            <div className="animate-spinSlow drop-shadow-md">⚽</div>
            <div className="animate-spinSlow drop-shadow-md">🏏</div>
            <div className="animate-spinSlow drop-shadow-md">🏸</div>
            <div className="animate-spinSlow drop-shadow-md">🏐</div>
            <div className="animate-spinSlow drop-shadow-md">🎾</div>
            <div className="animate-spinSlow drop-shadow-md">🏀</div>
            <div className="animate-spinSlow drop-shadow-md">🏓</div>
          </div>
          {!isSignedIn &&    <div className="flex flex-col sm:flex-row items-center gap-3 w-full sm:w-auto">
            <span
              key={currentMessageIndex}
              className="italic font-bold text-xs sm:text-sm md:text-base animate-slide-in text-center sm:text-left"
            >
              {rotatingMessages[currentMessageIndex]}
            </span>
    
    </div>}

        </div>
       
      </section>
      <div className="my-6 flex justify-center">
      <AdUnit clientId="ca-pub-2423094524642592" slotId="8814691723" />
      </div>

      <main className="flex-grow flex items-center justify-center p-4">
     
            {!isSignedIn ? 
           isSignInClicked && <div className="bg-gradient-to-r from-blue-50 via-blue-100 to-blue-50 text-gray-800 border border-blue-200 shadow-lg rounded-xl p-6 w-full max-w-md sm:max-w-xl mx-auto hover:shadow-2xl transition-shadow duration-300">
            <div className="text-center mb-4">
          <p className="text-2xl  mb-4 font-style: italic">
          {isRegisteredUserLogin
                  ? "Sign in to manage your tournaments"
                  : "Create an organizer account to get started"}
              </p>
            </div>
            <div className="flex justify-center mb-4">
              <button
                className={`px-4 py-1 rounded-l ${isRegisteredUserLogin ? "bg-blue-600 text-white font-style: italic" : "bg-blue-100 text-blue-800"}`}
                onClick={() => setIsRegisteredUserLogin(true)}
                type="button"
              >
                Login
              </button>
              <button
                className={`px-4 py-1 rounded-r ${!isRegisteredUserLogin ? "bg-blue-600 text-white font-style: italic" : "bg-blue-100 text-blue-800"}`}
            
                onClick={() => {
                  setIsRegisteredUserLogin(false)
                  setOrganizer({...organizer, email: '', password: '', confirmPassword: ''})
                }}

                type="button"
              >
                Register
              </button>
            </div>
            <h2 className="text-xl italic font-medium ">
              Organizer {isRegisteredUserLogin ? "Sign In" : "Registration"}
            </h2>
            <form onSubmit={handleSignIn} className="space-y-4">
            {!isRegisteredUserLogin && <input
                type="text"
                placeholder="Name"
                 pattern="^[A-Za-z ]+$"
   title="Name must contain only letters and spaces"
                value={organizer.name}
                onChange={(e) => setOrganizer({ ...organizer, name: e.target.value })}
                className="w-full p-2 border border-blue-300 focus:border-blue-500 focus:ring-blue-500 rounded bg-white text-black placeholder-gray-500"
                required
              />}
              <input
                type="email"
                placeholder="Email"
                value={organizer.email}
                onChange={(e) => setOrganizer({ ...organizer, email: e.target.value })}
                className="w-full p-3 text-base border border-blue-300 focus:border-blue-500 focus:ring-blue-500 rounded bg-white text-black placeholder-gray-500"
                required
              />
              
              <input
                type="password"
                pattern="^(?=(?:.*[A-Z]){1,})(?=(?:.*\d){6,}).*$"
  title="Password must contain at least 6 digits and 1 uppercase letter."
                placeholder="Password"
                value={organizer.password}
                onChange={(e) => setOrganizer({ ...organizer, password: e.target.value })}
                className="w-full p-2 border border-blue-300 focus:border-blue-500 focus:ring-blue-500 rounded bg-white text-black placeholder-gray-500"
                required
              />

{!isRegisteredUserLogin && <input
                type="password"
                pattern="^(?=(?:.*[A-Z]){1,})(?=(?:.*\d){6,}).*$"
  title="Password must contain at least 6 digits and 1 uppercase letter."
                placeholder="Confirm Password"
                value={organizer.confirmPassword}
                onChange={(e) => setOrganizer({ ...organizer, confirmPassword: e.target.value })}
                className="w-full p-2 border border-blue-300 focus:border-blue-500 focus:ring-blue-500 rounded bg-white text-black placeholder-gray-500"
                required
              />}

{isRegisteredUserLogin &&  <div
                onClick={() => setforgotPasswordtatusModal(true)}
                className="cursor-pointer bg-white/10 hover:bg-white/20 transition rounded p-4 text-center border border-white/20 shadow"
              >
              
                <h3 className="font-small text-lg mb-2 text-blue-800 underline underline-offset-4 font-style: italic">Forgot Password</h3>
              </div>}

              
              <button
                type="submit"
                className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 font-style: italic"
              >
                {isRegisteredUserLogin ? "Sign In" : "Register"}
              </button>
            </form>

          </div>
         : (
          <div className="bg-blue-50 text-black border border-blue-200 shadow-md rounded-lg p-6 w-full max-w-4xl">
            <h2 className="text-2xl font-bold mb-4 text-blue-800">Welcome to your Dashboard, {organizer.name}!</h2>
             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
             {organizer.role && <div
              onClick={(e) => {
                setShowTournamentModal(true);
              }}
                className="cursor-pointer bg-white/10 hover:bg-white/20 transition rounded p-4 text-center border border-white/20 shadow"
              >
                <h3 className="font-bold text-lg mb-2 text-blue-800">Create Tournament</h3>
                <p className="text-sm text-black/70">Register a new tournament with name, date, and location.</p>
              </div>}
              {organizer.role && <div
                onClick={(e) => {
                  setShowTeamModal(true);
                }}
                className="cursor-pointer bg-white/10 hover:bg-white/20 transition rounded p-4 text-center border border-white/20 shadow"
              >
                <h3 className="font-bold text-lg mb-2 text-blue-800">Create Team</h3>
                <p className="text-sm text-black/70">Build and register new teams for your tournaments.</p>
              </div>}
              {organizer.role && <div
               onClick={(e) => {
                setShowTeamPlayerModal(true);

              }}
                className="cursor-pointer bg-white/10 hover:bg-white/20 transition rounded p-4 text-center border border-white/20 shadow"
              >
                <h3 className="font-bold text-lg mb-2 text-blue-800">Manage Players</h3>
                <p className="text-sm text-black/70">Add or update player information across teams.</p>
              </div>}
              {organizer.role && <div
               onClick={(e) => {
                setShowFixturesModal(true);
              }}
                className="cursor-pointer bg-white/10 hover:bg-white/20 transition rounded p-4 text-center border border-white/20 shadow"
              >
                <h3 className="font-bold text-lg mb-2 text-blue-800">Create Fixtures</h3>
                <p className="text-sm text-black/70">Create fixtures for teams for a tournament.</p>
              </div>}
              <div
               onClick={(e) => {
                setViewFixturesModal(true);
              }}
                className="cursor-pointer bg-white/10 hover:bg-white/20 transition rounded p-4 text-center border border-white/20 shadow"
              >
              
                <h3 className="font-bold text-lg mb-2 text-blue-800">View Schedule&Status</h3>
                <p className="text-sm text-black/70">Stay on top of upcoming matches and tournament plans.</p>
              </div>

              {organizer.role &&<div
                onClick={(e) => {
                  setUpdateStatusModal(true);
                }}
                className="cursor-pointer bg-white/10 hover:bg-white/20 transition rounded p-4 text-center border border-white/20 shadow"
              >
              
                <h3 className="font-bold text-lg mb-2 text-blue-800">Update Match Status</h3>
                <p className="text-sm text-black/70">Update the status of completed matches and tournament plans.</p>
              </div>}



              <div
               onClick={(e) => {
                setLeaderDashboardModal(true);
              }}
                className="cursor-pointer bg-white/10 hover:bg-white/20 transition rounded p-4 text-center border border-white/20 shadow"
              >
              
                <h3 className="font-bold text-lg mb-2 text-blue-800">View Tournament Leaders </h3>
                <p className="text-sm text-black/70">View the leader dashboard of your tournament.</p>
              </div>

              <div>
            {organizer.role &&<div
             onClick={(e) => {
              setShowAdminTeamPlayer(true);
            }}
                className="cursor-pointer bg-white/10 hover:bg-white/20 transition rounded p-4 text-center border border-white/20 shadow">
              
                <h3 className="font-bold text-lg mb-2 text-blue-800">Manage Player Stats</h3>
                <p className="text-sm text-black/70">Allows tournament admins to update player statistics for each match in an ongoing tournament</p>
              </div>}
            </div>
            
            {organizer.role &&<div
             onClick={(e) => {
              setShowCertDownload(true);
            }}
                className="cursor-pointer bg-white/10 hover:bg-white/20 transition rounded p-4 text-center border border-white/20 shadow">
              
                <h3 className="font-bold text-lg mb-2 text-blue-800">Generate Tournament Certificate</h3>
                <p className="text-sm text-black/70">Download certificate for winner and player of the tournament</p>
              </div>}

            </div>


            


        {/* Tournament Details Modal */}
        {selectedTournament && (
        <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center">
          <div className="bg-blue-50 text-black rounded-lg p-6 w-full max-w-md shadow-lg">
           {/* <div className="fixed inset-0 z-50 bg-black/50 flex justify-end">
          <div className="bg-blue-50 text-black w-full sm:w-96 h-full p-6 shadow-lg overflow-y-auto"> */}
            <h2 className="text-xl font-bold mb-2">{selectedTournament.name}</h2>
            <p className="text-sm mb-2">📍 {selectedTournament.location} | 📅 {selectedTournament.date} | {selectedTournament.area} | {selectedTournament.sportName}</p>
            <h3 className="text-lg font-semibold mt-4 mb-2">Teams:</h3>
            <ul className="text-sm list-disc list-inside space-y-1 max-h-48 overflow-y-auto">
              {tournamentTeams.length > 0 ? (
                tournamentTeams.map((team) => <li key={team.id}>{team.name}  <button
          onClick={() => handleViewTeamDeatils(team.id)}
          className="text-blue-600 underline">
          Show Details
        </button></li>)
              ) : (
                <li className="italic text-gray-600">No teams registered</li>
              )}
            </ul>
            <div className="text-right mt-4">
              <button
                onClick={() => setSelectedTournament(null)}
                className="px-4 py-2 border border-blue-300 text-blue-800 rounded hover:bg-blue-100"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
        
          </div>
        )}
        {/* Tournament Modal */}
        {showTournamentModal && (
          
 <div className="fixed inset-0 z-50 bg-black/50">
 <div
    className="bg-blue-50 text-black rounded-lg p-6 w-full max-w-md shadow-lg absolute"
    style={{
      top: "150px",    // fixed distance from top
      left: "50%",     // center horizontally
      transform: "translateX(-50%)",
    }}
  >
 
       {/* Toast message at top */}
       {toastMessage && (
              <div className="bg-red-100 border border-red-400 text-red-700 rounded p-2 mb-4 animate-fade-in-down">
                {toastMessage}
              </div>
            )}
      <h2 className="text-lg sm:text-xl font-bold mb-4 text-blue-800">Create Tournament</h2>
      
      <form
        onSubmit={async (e) => {
          e.preventDefault();
          try {
            const token = localStorage.getItem('token');
            const res = await fetch(`${apiUrl}/tournaments`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Authorization':  `Bearer ${token}`},
              body: JSON.stringify({ ...tournament, creator: organizer.email }),
            });
            if (res.ok) {
              toast.success('Tournament created successfully!');
              setTournament({ name: '', date: '', endDate: '', location: '', area: '', privateTournament: false, sportName: '', creator: '', contactNo : '', venue: '' });
              setShowTournamentModal(false);
              const refreshed = await fetch(`${apiUrl}/alltournaments`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization':  `Bearer ${token}`},
                body: JSON.stringify({ ...organizer, email: organizer.email }),
              });
              const data = await refreshed.json();
              setUserTournaments(data);
            } else {
              setTournament({ name: '', date: '', endDate: '', location: '', area: '', privateTournament: false, sportName: '', creator: '', contactNo : '', venue: '' });
              toast.error('Failed to create tournament');
            }
          } catch (err) {
            setTournament({ name: '', date: '', endDate: '', location: '', area: '', privateTournament: false, sportName: '', creator: '', contactNo : '', venue: '' });
            toast.error('Error occurred while creating tournament');
            console.error(err);
          }
        }}
        className="space-y-4"
      >
        {/* Tournament Name */}
        <input
          type="text"
          placeholder="Tournament Name"
          value={tournament.name}
          onChange={(e) => setTournament({ ...tournament, name: e.target.value })}
          className="w-full p-3 text-base border border-blue-300 focus:border-blue-500 focus:ring-blue-500 rounded bg-white text-black placeholder-gray-500"
          required
        />

        {/* Sport Select */}
        <select
          value={tournament.sportName}
          onChange={(e) => setTournament({ ...tournament, sportName: e.target.value })}
          className="w-full p-3 text-base min-h-[44px] border border-blue-300 focus:border-blue-500 focus:ring-blue-500 rounded bg-white text-black placeholder-gray-500"          required
        >
          <option value="">Select Sport</option>
          {sports.map((sport, idx) => (
            <option key={idx} value={sport}>{sport}</option>
          ))}
        </select>

        {/* Start Date */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Start Date</label>
          <input
            type="datetime-local"
            value={tournament.date}
            onChange={(e) => {
              const selectedDate = new Date(e.target.value);
              if (selectedDate < new Date()) {
               showErrorToast("Start date cannot be in the past.");
                return;
              }
              setTournament({ ...tournament, date: e.target.value });
            }}
            className="w-full p-3 text-base min-h-[44px] leading-tight border border-blue-300 focus:border-blue-500 focus:ring-blue-500 rounded bg-white text-black placeholder-gray-500"
            required
          />
        </div>

        {/* End Date */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">End Date</label>
          <input
            type="datetime-local"
            value={tournament.endDate}
            onChange={(e) => {
              const selectedDate = new Date(e.target.value);
              if (selectedDate < new Date()) {
                showErrorToast("End date cannot be in the past.");
                return;
              }
              setTournament({ ...tournament, endDate: e.target.value });
            }}
            className="w-full p-3 text-base border border-blue-300 focus:border-blue-500 focus:ring-blue-500 rounded bg-white text-black"
            required
          />
        </div>

        {/* City */}
        <select
          value={tournament.location}
          onChange={(e) => setTournament({ ...tournament, location: e.target.value })}
          className="w-full p-3 text-base min-h-[44px] border border-blue-300 focus:border-blue-500 focus:ring-blue-500 rounded bg-white text-black placeholder-gray-500"          required
        >
          <option value="">Select City</option>
          {cities.map((city, idx) => (
            <option key={idx} value={city}>{city}</option>
          ))}
        </select>

        {/* Area */}
        <input
          type="text"
          placeholder="Area"
          value={tournament.area}
          onChange={(e) => setTournament({ ...tournament, area: e.target.value })}
          className="w-full p-3 text-base border border-blue-300 focus:border-blue-500 focus:ring-blue-500 rounded bg-white text-black placeholder-gray-500"
          required
        />

        {/* Venue */}
        <input
          type="text"
          placeholder="Venue"
          value={tournament.venue}
          onChange={(e) => setTournament({ ...tournament, venue: e.target.value })}
          className="w-full p-3 text-base border border-blue-300 focus:border-blue-500 focus:ring-blue-500 rounded bg-white text-black placeholder-gray-500"
          required
        />

        {/* Contact Number */}
        <input
          type="text"
          pattern="^\d{10}$"
          title="Please enter 10 digit mobile number."
          placeholder="Contact No to get notification"
          value={tournament.contactNo}
          onChange={(e) => setTournament({ ...tournament, contactNo: e.target.value })}
          className="w-full p-3 text-base border border-blue-300 focus:border-blue-500 focus:ring-blue-500 rounded bg-white text-black placeholder-gray-500"
          required
        />

        {/* Private Checkbox with Tooltip */}
        <label className="flex items-center space-x-2">
          <input
            type="checkbox"
            checked={tournament.privateTournament}
            onChange={(e) => setTournament({ ...tournament, privateTournament: e.target.checked })}
            className="accent-blue-600"
          />
          <span className="text-sm text-black">Make this tournament private</span>
          <div className="relative group">
            <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-gray-500 hover:text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <circle cx="12" cy="12" r="10" strokeWidth="2" />
              <line x1="12" y1="8" x2="12" y2="8" strokeWidth="2" />
              <line x1="12" y1="12" x2="12" y2="16" strokeWidth="2" />
            </svg>
            <div className="absolute left-1/2 -translate-x-1/2 bottom-full mb-2 hidden group-hover:block bg-gray-800 text-white text-xs rounded px-2 py-1 whitespace-nowrap">
              Private tournament is not visible to others.
            </div>
          </div>
        </label>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row justify-end gap-2 pt-2">
          <button
            type="button"
            onClick={() => {
              setShowTournamentModal(false);
              setTournament({ name: '', date: '', endDate: '', location: '', area: '', privateTournament: false, sportName: '', creator: '', contactNo: '', venue: '' });
            }}
            className="w-full sm:w-auto px-4 py-3 border border-blue-300 text-blue-800 rounded hover:bg-blue-100"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="w-full sm:w-auto px-4 py-3 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Submit
          </button>
        </div>
      </form>
    </div>
  </div>
)}
{showTeamModal && (
 <div className="fixed inset-0 z-50 bg-black/50">
 <div
    className="bg-blue-50 text-black rounded-lg p-6 w-full max-w-md shadow-lg absolute"
    style={{
      top: "250px",    // fixed distance from top
      left: "50%",     // center horizontally
      transform: "translateX(-50%)",
    }}
  >
    <h2 className="text-lg sm:text-xl font-bold mb-4 text-blue-800">
      Create Team
    </h2>

      <form
        onSubmit={async (e) => {
          e.preventDefault();
          try {
            const token = localStorage.getItem('token');
            const res = await fetch(`${apiUrl}/teams`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Authorization':  `Bearer ${token}`},
              body: JSON.stringify(newTeam),
            });
            if (res.ok) {
              toast.success('Team created successfully!');
              setNewTeam({ name: '', tournamentId: '', contactNo: '' });
              setShowTeamModal(false);
            } else {
              toast.error("Failed to create team");
              setNewTeam({ name: '', tournamentId: '', contactNo: '' });
            }
          } catch (err) {
            setNewTeam({ name: '', tournamentId: '', contactNo: '' });
            toast.error('Error occurred while creating team');
            console.error(err);
          }
        }}
        className="space-y-4"
      >
        {/* Team Name */}
        <input
          type="text"
          placeholder="Team Name"
          pattern="^[A-Za-z\\- ]+$"
          title="Name can contain only letters, spaces, and hyphens"
          value={newTeam.name}
          onChange={(e) => setNewTeam({ ...newTeam, name: e.target.value })}
          className="w-full p-3 text-base border border-blue-300 focus:border-blue-500 focus:ring-blue-500 rounded bg-white text-black placeholder-gray-500"
          required
        />

        {/* Contact Number */}
        <input
          type="text"
          placeholder="Team Contact No"
          pattern="^\d{10}$"
          title="Please enter 10 digit mobile number."
          value={newTeam.contactNo}
          onChange={(e) => setNewTeam({ ...newTeam, contactNo: e.target.value })}
          className="w-full p-3 text-base border border-blue-300 focus:border-blue-500 focus:ring-blue-500 rounded bg-white text-black placeholder-gray-500"
          required
        />

        {/* Tournament Select */}
        <select
          value={newTeam.tournamentId}
          onChange={(e) => setNewTeam({ ...newTeam, tournamentId: e.target.value })}
          className="w-full p-3 text-base border border-blue-300 focus:border-blue-500 focus:ring-blue-500 rounded bg-white text-black"
          required
        >
          <option value="">Select Tournament</option>
          {userTournaments.map((t) => (
            <option key={t.id} value={t.id}>{t.name}</option>
          ))}
        </select>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row justify-end gap-2 pt-2">
          <button
            type="button"
            onClick={() => {
              setShowTeamModal(false);
              setNewTeam({ ...newTeam, tournamentId: '', contactNo: '', name: ''});
            }}

            className="w-full sm:w-auto px-4 py-3 border border-blue-300 text-blue-800 rounded hover:bg-blue-100"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="w-full sm:w-auto px-4 py-3 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Submit
          </button>
        </div>
      </form>
    </div>
  </div>
)}



{showFixturesModal && (
 <div className="fixed inset-0 z-50 bg-black/50">
<div
    className="bg-blue-50 text-black rounded-lg p-6 w-full max-w-md shadow-lg absolute"
    style={{
      top: "150px",    // fixed distance from top
      left: "50%",     // center horizontally
      transform: "translateX(-50%)",
    }}
  >
             {/* Toast message at top */}
       {toastMessage && (
              <div className="bg-red-100 border border-red-400 text-red-700 rounded p-2 mb-4 animate-fade-in-down">
                {toastMessage}
              </div>
            )}
      <h2 className="text-lg sm:text-xl font-bold mb-4 text-blue-800">Create Fixtures</h2>

      <form
        onSubmit={async (e) => {
          e.preventDefault();
          try {
            if (newFixture.tournamentType === "own" && newFixture.teamA === newFixture.teamB) {
              return toast.error('Both teams are same, change the teams');
            }
            const token = localStorage.getItem('token');
            const res = await fetch(`${apiUrl}/fixture`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
              body: JSON.stringify(newFixture),
            });
            if (res.ok) {
              toast.success('Fixture created successfully!');
              setNewFixture({ tournamentId: '' });
              setShowFixturesModal(false);
            } else {
              toast.error('Failed to create fixture, please try again');
              setNewFixture({ tournamentId: '', startDate: '', tournamentType: '' });
            }
          } catch (err) {
            toast.error('Error occurred while creating fixture');
            console.error(err);
            setNewFixture({ tournamentId: '', startDate: '', tournamentType: '' });
          }
        }}
        className="space-y-4"
      >
        {/* Tournament Select */}
        <select
          value={newFixture.tournamentId}
          onChange={async (e) => {
            const val = e.target.value;
            setNewFixture({ ...newFixture, tournamentId: val, teamA: '', teamB: '', startDate: '', stage: '', tournamentType: '' });
            handleViewTournaments(val);
          }}
          className="w-full p-3 text-base border border-blue-300 focus:border-blue-500 focus:ring-blue-500 rounded bg-white text-black"
          required
        >
          <option value="">Select Tournament</option>
          {userTournaments.map((t) => (
            <option key={t.id} value={t.id}>{t.name}</option>
          ))}
        </select>

        {/* Schedule Date */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Schedule Date</label>
          <input
            type="datetime-local"
            value={newFixture.startDate}
            onChange={(e) => {
              const selectedDate = new Date(e.target.value);
              if (selectedDate < new Date()) {
                setToastMessage("Start date cannot be in the past.")
                return;
              }
              setNewFixture({ ...newFixture, startDate: e.target.value });
            }}
            className="w-full p-3 text-base border border-blue-300 focus:border-blue-500 focus:ring-blue-500 rounded bg-white text-black"
            required
          />
        </div>

        {/* Matches per day */}
        <select
          value={newFixture.matchesPerDay}
          onChange={(e) => setNewFixture({ ...newFixture, matchesPerDay: parseInt(e.target.value, 10) })}
          className="w-full p-3 text-base border border-blue-300 focus:border-blue-500 focus:ring-blue-500 rounded bg-white text-black"
          required
        >
          <option value="">Select Matches Per Day</option>
          {[1,2,3,4,5].map(num => <option key={num} value={num}>{num}</option>)}
        </select>

        {/* Interval Hours */}
        <select
          value={newFixture.intervalHours}
          onChange={(e) => setNewFixture({ ...newFixture, intervalHours: parseInt(e.target.value, 10) })}
          className="w-full p-3 text-base border border-blue-300 focus:border-blue-500 focus:ring-blue-500 rounded bg-white text-black"
          required
        >
          <option value="">Select Matches Interval Hours</option>
          {[1,2,3,4,5].map(num => <option key={num} value={num}>{num}</option>)}
        </select>

        {/* Tournament Type Radios */}
        <div className="space-y-2">
          <label className="flex items-center space-x-2">
            <input
              type="radio"
              checked={newFixture.tournamentType === "own"}
              value="own"
              onChange={(e) => setNewFixture({ ...newFixture, tournamentType: e.target.value })}
              className="accent-blue-600"
            />
            <span className="text-sm text-black">Do you want to create your own fixture</span>
          </label>

          <label className="flex items-center space-x-2">
            <input
              type="radio"
              checked={newFixture.tournamentType === "single"}
              value="single"
              onChange={(e) => setNewFixture({ ...newFixture, tournamentType: e.target.value })}
              className="accent-blue-600"
            />
            <span className="text-sm text-black">Single Elimination</span>
          </label>

          <label className="flex items-center space-x-2">
            <input
              type="radio"
              checked={newFixture.tournamentType === "double"}
              value="double"
              onChange={(e) => setNewFixture({ ...newFixture, tournamentType: e.target.value })}
              className="accent-blue-600"
            />
            <span className="text-sm text-black">Double Elimination</span>
          </label>

          <label className="flex items-center space-x-2">
            <input
              type="radio"
              value="roundrobin"
              checked={newFixture.tournamentType === "roundrobin"}
              onChange={(e) => setNewFixture({ ...newFixture, tournamentType: e.target.value })}
              className="accent-blue-600"
            />
            <span className="text-sm text-black">Round Robin</span>
          </label>

          <label className="flex items-center space-x-2">
            <input
              type="radio"
              value="doubleroundrobin"
              checked={newFixture.tournamentType === "doubleroundrobin"}
              onChange={(e) => setNewFixture({ ...newFixture, tournamentType: e.target.value })}
              className="accent-blue-600"
            />
            <span className="text-sm text-black">Double Round Robin</span>
          </label>
        </div>

        {/* Team selects only if "own" */}
        {newFixture.tournamentType === "own" && (
          <>
            <select
              value={newFixture.teamA}
              onChange={(e) => setNewFixture({ ...newFixture, teamA: e.target.value })}
              className="w-full p-3 text-base border border-blue-300 focus:border-blue-500 focus:ring-blue-500 rounded bg-white text-black"
              required
            >
              <option value="">Select Team 1</option>
              {tournamentTeams.map((t) => (
                <option key={t.id} value={t.name}>{t.name}</option>
              ))}
            </select>

            <select
              value={newFixture.teamB}
              onChange={(e) => setNewFixture({ ...newFixture, teamB: e.target.value })}
              className="w-full p-3 text-base border border-blue-300 focus:border-blue-500 focus:ring-blue-500 rounded bg-white text-black"
              required
            >
              <option value="">Select Team 2</option>
              {tournamentTeams.map((t) => (
                <option key={t.id} value={t.name}>{t.name}</option>
              ))}
            </select>
          </>
        )}

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row justify-end gap-2 pt-2">
          <button
            type="button"
            onClick={() => {
              setShowFixturesModal(false);
              setNewFixture({ ...newFixture, tournamentId: '', teamA: '', teamB: '', ownFixture: '', startDate: '', stage: '', tournamentType: '', matchesPerDay: '', intervalHours: '' });
            }}
            className="w-full sm:w-auto px-4 py-3 border border-blue-300 text-blue-800 rounded hover:bg-blue-100"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="w-full sm:w-auto px-4 py-3 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Submit
          </button>
        </div>
      </form>
    </div>
  </div>
)}


{viewFixturesModal && (
 <div className="fixed inset-0 z-50 bg-black/50">
 <div
    className="bg-blue-50 text-black rounded-lg p-6 w-full max-w-md shadow-lg absolute"
    style={{
      top: "360px",    // fixed distance from top
      left: "50%",     // center horizontally
      transform: "translateX(-50%)",
    }}
  >    <h2 className="text-xl font-bold mb-4 text-blue-800">Fixtures</h2>
            
              <form
                onSubmit={async (e) => {
                  e.preventDefault();
                  try {
                    const token = localStorage.getItem('token');
                          const res = await fetch(`${apiUrl}/fixture?tournamentId=${viewFixture.tournamentId}`, {
                            method: 'GET',
                            headers: { 'Content-Type': 'application/json', 'Authorization':  `Bearer ${token}` },
                          });
                          if (res.ok) {
                            toast.success('Fixture fetched successfully!');
                            setViewFixturesModal(false);
                            setViewFixture({ tournamentId: ''});
                            const data = await res.json();
                          
                            setAllFixtures(data);
                            setListFixturesModal(true)
                            setLeaderDashboard(data)
                          } else {
                            toast.error('Failed to fetch fixture');
                            setViewFixture({ tournamentId: ''});
                          }
                        } catch (err) {
                          toast.error('Error occurred while fetching fixture');
                          console.error(err);
                          setViewFixture({ tournamentId: ''});
                        }
                }}
                className="space-y-4"
              >
        

          <select
                  value={viewFixture.tournamentId}
                  onChange={(e) => setViewFixture({ ...viewFixture, tournamentId: e.target.value })}
                  className="w-full p-2 border border-blue-300 focus:border-blue-500 focus:ring-blue-500 rounded bg-white text-black"
                  required
                >
                  <option value="">Select Tournament</option>
                  {userTournaments.map((t) => (
                    <option key={t.id} value={t.id}>{t.name}</option>
                  ))}
                </select>

            
                <div className="flex justify-end gap-2">
                  <button
                    type="button"
                    onClick={() => {
                      setViewFixturesModal(false);
                      setViewFixture({ tournamentId: ''});
                    }}
                    className="px-4 py-2 border border-blue-300 text-blue-800 rounded hover:bg-blue-100"
                  >
                    Cancel
                  </button>
                  <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}




{ leaderDashboardModal && (
 <div className="fixed inset-0 z-50 bg-black/50">
 <div
    className="bg-blue-50 text-black rounded-lg p-6 w-full max-w-md shadow-lg absolute"
    style={{
      top: "470px",    // fixed distance from top
      left: "50%",     // center horizontally
      transform: "translateX(-50%)",
    }}
  >           <h2 className="text-xl font-bold mb-4 text-blue-800">Tournament Leaders</h2>
            
              <form
                onSubmit={async (e) => {
                  e.preventDefault();
                  try {
                    const token = localStorage.getItem('token');
                          const res = await fetch(`${apiUrl}/leader-board?tournamentId=${leaderDashboard.tournamentId}`, {
                            method: 'GET',
                            headers: { 'Content-Type': 'application/json', 'Authorization':  `Bearer ${token}` },
                          });
                          if (res.ok) {
                           // toast.success('Tournament leaders fetched successfully!');
                            setLeaderDashboardModal(false);
                            setLeaderDashboard({ tournamentId: ''});
                            const data = await res.json();
                            setListLeadersData(data);
                            setListLeaderModal(true)
                          } else {
                            toast.error('Failed to fetch tournament leaders');
                            setLeaderDashboard({ tournamentId: ''});
                          }
                        } catch (err) {
                          toast.error('Error occurred while fetching tournament leaders');
                          console.error(err);
                          setLeaderDashboard({ tournamentId: ''});
                        }
                }}
                className="space-y-4"
              >
        

          <select
                  value={leaderDashboard.tournamentId}
                  onChange={(e) => setLeaderDashboard({ ...leaderDashboard, tournamentId: e.target.value })}
                  className="w-full p-2 border border-blue-300 focus:border-blue-500 focus:ring-blue-500 rounded bg-white text-black"
                  required
                >
                  <option value="">Select Tournament</option>
                  {userTournaments.map((t) => (
                    <option key={t.id} value={t.id}>{t.name}</option>
                  ))}
                </select>

            
                <div className="flex justify-end gap-2">
                  <button
                    type="button"
                    onClick={() => {
                      setLeaderDashboardModal(false);
                      setLeaderDashboard({ ...leaderDashboard, tournamentId: ''})
                    }}

                    className="px-4 py-2 border border-blue-300 text-blue-800 rounded hover:bg-blue-100"
                  >
                    Cancel
                  </button>
                  <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}




{ showAdminTeamPlayer && (
 <div className="fixed inset-0 z-50 bg-black/50">
 <div
    className="bg-blue-50 text-black rounded-lg p-6 w-full max-w-md shadow-lg absolute"
    style={{
      top: "480px",    // fixed distance from top
      left: "50%",     // center horizontally
      transform: "translateX(-50%)",
    }}
  >  
              <h2 className="text-xl font-bold mb-4 text-blue-800">Manage Player Stats</h2>
            
              <form
                onSubmit={async (e) => {
                  e.preventDefault();
                  try {
                    const token = localStorage.getItem('token');
                    const res = await fetch(`${apiUrl}/team-stats`, {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json', 'Authorization':  `Bearer ${token}`},
                      body: JSON.stringify(managePlayerStats),
                    });
                    if (res.ok) {
                      toast.success('Player stats updated successfully!');
                      setShowAdminTeamPlayer(false)
                    } else {
                      toast.error('Failed to updaye player stats');
                      setShowAdminTeamPlayer(false)
                    }
                  } catch (err) {
                    toast.error('Error occurred while updating player stats');
                    console.error(err);
                    setShowAdminTeamPlayer(false)
                  }
                }}
                className="space-y-4"
              >
        

          <select
                  value={managePlayerStats.tournamentId}
                  onChange={(e) => {
                    const selectedId = e.target.value;
                    // Always update the state
                    setManagePlayerStats({ ...managePlayerStats, tournamentId: e.target.value })
                    // Only call API if a real tournament is selected
                    if (selectedId) {
                      handleTeamPlayerStatsChange(selectedId);
                    }
                  }}
                  className="w-full p-2 border border-blue-300 focus:border-blue-500 focus:ring-blue-500 rounded bg-white text-black"
                  required
                >
                  <option value="">Select Tournament</option>
                  {userTournaments.map((t) => (
                    <option key={t.id} value={t.id}>{t.name}</option>
                  ))}
                </select>
                

           {managePlayerStats.tournamentId !== '' && teamPlayerStatDetails?.team &&  <select
                  value={managePlayerStats.teamId}
                  onChange={(e) => setManagePlayerStats({ ...managePlayerStats, teamId: e.target.value })}
                  disabled={!teamPlayerStatDetails || teamPlayerStatDetails.team.length === 0}
                  className="w-full p-2 border border-blue-300 focus:border-blue-500 focus:ring-blue-500 rounded bg-white text-black"
                  required
                >
                  <option value="">Select Team</option>
                  {teamPlayerStatDetails.team.map((t) => (
                    <option key={t.id} value={t.id}>{t.name}</option>
                  ))}
                </select>}


                {managePlayerStats.tournamentId !== '' && teamPlayerStatDetails?.teamPlayerMap && <select
                  value={managePlayerStats.teamPlayerId}
                  onChange={(e) => setManagePlayerStats({ ...managePlayerStats, teamPlayerId: e.target.value })}
                  className="w-full p-2 border border-blue-300 focus:border-blue-500 focus:ring-blue-500 rounded bg-white text-black"
                  required
                >
                 <option value="">Select Team Player</option>
{(teamPlayerStatDetails?.teamPlayerMap?.[managePlayerStats?.teamId] || []).map((t) => (
  <option key={t.id} value={t.id}>
    {t.name}
  </option>
))}
                </select>}

                {managePlayerStats.tournamentId !== '' && <input
                  type="text"
                  placeholder="Enter points, runs, or goals as per the sport"
                  value={managePlayerStats.playerScore}
                  onChange={(e) => setManagePlayerStats({ ...managePlayerStats, playerScore: e.target.value })}
                  className="w-full p-2 border border-blue-300 focus:border-blue-500 focus:ring-blue-500 rounded bg-white text-black placeholder-gray-500"
                  required
                />}
            
                <div className="flex justify-end gap-2">
                  <button
                    type="button"
                    onClick={() => {
                      setShowAdminTeamPlayer(false);
                      setManagePlayerStats({ ...managePlayerStats, tournamentId: '', teamId: '', teamPlayerId: '', playerScore: ''})
                    }}

                    className="px-4 py-2 border border-blue-300 text-blue-800 rounded hover:bg-blue-100"
                  >
                    Cancel
                  </button>
                  <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}



{ showCertDownload && (
 <div className="fixed inset-0 z-50 bg-black/50">
 <div
    className="bg-blue-50 text-black rounded-lg p-6 w-full max-w-md shadow-lg absolute"
    style={{
      top: "500px",    // fixed distance from top
      left: "50%",     // center horizontally
      transform: "translateX(-50%)",
    }}
  >  
              <h2 className="text-xl font-bold mb-4 text-blue-800">Download Digital Certificate</h2>
            
              <form
                onSubmit={async (e) => {
                  e.preventDefault();
                  try {
                    const token = localStorage.getItem('token');
                    const res = await fetch(`${apiUrl}/generate-certificate`, {
                      method: "POST",
                      headers: { "Content-Type": "application/json", 'Authorization': `Bearer ${token}` },
                      body: JSON.stringify(certRequest),
                    });
              
                    if (!res.ok) {
                      toast.error("Failed to generate certificate");
                      setShowCertDownload(false)
                      setCertRequest({ ...certRequest, tournamentId: '', award: '', name: ''})
                    } else {
                    // Convert response to Blob
                    const blob = await res.blob();
                    const url = window.URL.createObjectURL(blob);
              
                    // Create a temporary download link
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = `certificate_${certRequest.award}.pdf`;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(url);
                    }
                  } catch (err) {
                    setCertRequest({ ...certRequest, tournamentId: '', award: '', name: ''})
                    setShowCertDownload(false)
                    console.error(err);
                    toast.error("Error generating certificate");
                  }
                }}
                className="space-y-4"
              >
        
        <select
                  value={certRequest.tournamentId}
                  onChange={(e) => setCertRequest({ ...certRequest, tournamentId: e.target.value })}
                  className="w-full p-2 border border-blue-300 focus:border-blue-500 focus:ring-blue-500 rounded bg-white text-black"
                  required
                >
                  <option value="">Select Tournament</option>
                  {userTournaments.map((t) => (
                    <option key={t.id} value={t.id}>{t.name}</option>
                  ))}
                </select>


                <select
                  value={certRequest.award}
                  onChange={(e) => setCertRequest({ ...certRequest, award: e.target.value })}
                  className="w-full p-2 border border-blue-300 focus:border-blue-500 focus:ring-blue-500 rounded bg-white text-black"
                  required
                >
                  <option value="">Select Award</option>
                 <option value="Winner">Winner</option>
                 <option value="Player Of The Tournament">Player Of The Tournament</option>
                </select>

              <input
                  type="text"
                  placeholder="Enter your academy/organisation name to print on certificate"
                  value={certRequest.name}
                  onChange={(e) => setCertRequest({ ...certRequest, name: e.target.value })}
                  className="w-full p-2 border border-blue-300 focus:border-blue-500 focus:ring-blue-500 rounded bg-white text-black placeholder-gray-500"
                  required
                />
            
                <div className="flex justify-end gap-2">
                  <button
                    type="button"
                    onClick={() => {
                      setShowCertDownload(false);
                      setCertRequest({ ...certRequest, tournamentId: '', award: '', name: ''})
                    }}

                    className="px-4 py-2 border border-blue-300 text-blue-800 rounded hover:bg-blue-100"
                  >
                    Cancel
                  </button>
                  <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}



{updateStatusModal && (
 <div className="fixed inset-0 z-50 bg-black/50">
 <div
    className="bg-blue-50 text-black rounded-lg p-6 w-full max-w-md shadow-lg absolute"
    style={{
      top: "390px",    // fixed distance from top
      left: "50%",     // center horizontally
      transform: "translateX(-50%)",
    }}
  >  
              <h2 className="text-xl font-bold mb-4 text-blue-800">Update Fixtures</h2>
            
              <form
                onSubmit={async (e) => {
                  e.preventDefault();
                  try {
                   
                    const token = localStorage.getItem('token');
                          const res = await fetch(`${apiUrl}/fixture`, {
                            method: 'PUT',
                            headers: { 'Content-Type': 'application/json', 'Authorization':  `Bearer ${token}` },
                            body: JSON.stringify(updateStatus),
                          });
                          if (res.ok) {
                            toast.success('Status updated successfully!');
                            setUpdateStatusModal(false);
                            setUpdateStatus({ tournamentId: '', fixtureId: '', matchStatus: '', winner: '', scoreCard: '', playerOfTheMatch: ''});                      
                          } else {
                            toast.error('Failed to update status');
                            setUpdateStatus({ tournamentId: '', fixtureId: '', matchStatus: '', winner: '', scoreCard: '', playerOfTheMatch: ''});
                          }
                        } catch (err) {
                          toast.error('Error occurred while update status');
                          console.error(err);
                          setUpdateStatus({ tournamentId: '', fixtureId: '', matchStatus: '', winner: '', scoreCard: '', playerOfTheMatch: ''});
                        }
                }}
                className="space-y-4"
              >
        

          <select
                  value={updateStatus.tournamentId}
                  onChange={async (e) => {
                    const val = e.target.value;
                    setUpdateStatus({ ...updateStatus, tournamentId: e.target.value})
                    handleViewFixturesForStatus(val);
                    handleViewTournaments(val)
                   
                  }}

                  className="w-full p-2 border border-blue-300 focus:border-blue-500 focus:ring-blue-500 rounded bg-white text-black"
                  required
                >
                  <option value="">Select Tournament</option>
                  {userTournaments.map((t) => (
                    <option key={t.id} value={t.id}>{t.name}</option>
                  ))}
                </select>


                <select
                  value={updateStatus.fixtureId}
                  onChange={(e) => setUpdateStatus({ ...updateStatus, fixtureId: e.target.value })}
                  className="w-full p-2 border border-blue-300 focus:border-blue-500 focus:ring-blue-500 rounded bg-white text-black"
                  required
                >
                  <option value="">Select Match</option>
                  {allFixtures.map((t) => (
                    <option key={t.id} value={t.fixtureId}>Match: {t.matchId} {t.teamA} vs {t.teamB}</option>
                  ))}
                </select>

                <select
                  value={updateStatus.winner}
                  onChange={(e) => setUpdateStatus({ ...updateStatus, winner: e.target.value })}
                  className="w-full p-2 border border-blue-300 focus:border-blue-500 focus:ring-blue-500 rounded bg-white text-black"
                  required
                >
                  <option value="">Select Winning Team</option>
                  <option key="NA" value="NA">NA</option>
                  {tournamentTeams.map((t) => (
                    <option key={t.id} value={t.value}>{t.name}</option>
                  ))}
                </select>

                <input
                  type="text"
                  placeholder="Enter scorecard of loss or win"
                  value={updateStatus.scoreCard}
                  onChange={(e) => setUpdateStatus({ ...updateStatus, scoreCard: e.target.value })}
                  className="w-full p-2 border border-blue-300 focus:border-blue-500 focus:ring-blue-500 rounded bg-white text-black placeholder-gray-500"
                  required
                />

                

                <select
                  value={updateStatus.matchStatus}
                  onChange={(e) => setUpdateStatus({ ...updateStatus, matchStatus: e.target.value })}
                  className="w-full p-2 border border-blue-300 focus:border-blue-500 focus:ring-blue-500 rounded bg-white text-black"
                  required
                >
                  <option value="">Select Match Status</option>
                  {Object.entries(MATCH_STATUS).map(([key, label]) => (
    <option key={key} value={key}>
      {label}
    </option>
  ))}
                </select>

                <input
                  type="text"
                  placeholder="Enter player name who got player of the match (Optional)"
                  value={updateStatus.playerOfTheMatch}
                  onChange={(e) => setUpdateStatus({ ...updateStatus, playerOfTheMatch: e.target.value })}
                  className="w-full p-2 border border-blue-300 focus:border-blue-500 focus:ring-blue-500 rounded bg-white text-black placeholder-gray-500"
                />

            
                <div className="flex justify-end gap-2">
                  <button
                    type="button"
                    onClick={() => {
                      setUpdateStatusModal(false);
                      setUpdateStatus({ ...updateStatus, tournamentId: '', fixtureId: '', matchStatus: '', winner: '', scoreCard: '', playerOfTheMatch: '' })
                    }}
                    className="px-4 py-2 border border-blue-300 text-blue-800 rounded hover:bg-blue-100"
                  >
                    Cancel
                  </button>
                  <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}


{forgotPasswordtatusModal && (
          <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center h-screen">
            <div className="bg-blue-50 text-black rounded-lg p-6 w-full max-w-md shadow-lg">
               {/* Toast message at top */}
       {toastMessage && (
              <div className="bg-red-100 border border-red-400 text-red-700 rounded p-2 mb-4 animate-fade-in-down">
                {toastMessage}
              </div>
            )}
              <h2 className="text-xl font-bold mb-4 text-blue-900 font-style: italic">Enter Email To Get Login Password</h2>
            
              <form
                onSubmit={async (e) => {
                  e.preventDefault();
                  handleCaptchaValidate()
                
                 
                  if (captchaValidation){
                   try {
                     if (passwordReset.password !== passwordReset.confirmPassword ) {
                      setToastMessage("Password does not match")
                      return
                     }

                    passwordReset.notificationType = "FORGOT_PASSWORD"
                           const res = await fetch(`${apiUrl}/send-notification`, {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json', 'API_KEY': `${apiKey}`},
                            body: JSON.stringify(passwordReset),
                          });
                          if (res.ok) {
                            toast.success('If the email exists, a reset link has been sent!');
                            setforgotPasswordtatusModal(false);
                            setPasswordReset({ ...passwordReset, emailId: '', password: '', confirmPassword: '',  notificationType: '' })         
                            setCaptchaValidation(false)   
                            setCaptchaInput('')        
                          } else {
                            toast.error('Failed to reset password email');
                            setforgotPasswordtatusModal(false);
                            setPasswordReset({ ...passwordReset, emailId: '', password: '', confirmPassword: '',  notificationType: '' }) 
                            setCaptchaValidation(false)
                            setCaptchaInput('')
                          }
                        } catch (err) {
                          toast.error('Error occurred while resetting password');
                          console.error(err);
                          setforgotPasswordtatusModal(false);
                          setPasswordReset({ ...passwordReset, emailId: '', password: '', confirmPassword: '',  notificationType: '' }) 
                      setCaptchaValidation(false)
                      setCaptchaInput('')
                        }
                      }
                }}
                className="space-y-4"
              >

<div>
      <label>
        What is {num1} + {num2}?
        <input
          type="text"
          value={captchaInput}
          className="w-full p-2 border border-blue-300 focus:border-blue-500 focus:ring-blue-500 rounded bg-white text-black placeholder-gray-500"

          onChange={(e) => setCaptchaInput(e.target.value)}
          required
        />
      </label>
     
    </div>
        
        <input
                type="email"
                placeholder="Email"
                value={passwordReset.emailId}
                onChange={(e) => setPasswordReset({ ...passwordReset, emailId: e.target.value})}
                className="w-full p-2 border border-blue-300 focus:border-blue-500 focus:ring-blue-500 rounded bg-white text-black placeholder-gray-500"
                required
              />

<input
                type="password"
                pattern="^(?=(?:.*[A-Z]){1,})(?=(?:.*\d){6,}).*$"
  title="Password must contain at least 6 digits and 1 uppercase letter."
                placeholder="Password"
                value={passwordReset.password}
                onChange={(e) => setPasswordReset({ ...passwordReset, password: e.target.value })}
                className="w-full p-2 border border-blue-300 focus:border-blue-500 focus:ring-blue-500 rounded bg-white text-black placeholder-gray-500"
                required
              />
         

         <input
                type="password"
                pattern="^(?=(?:.*[A-Z]){1,})(?=(?:.*\d){6,}).*$"
  title="Password must contain at least 6 digits and 1 uppercase letter."
                placeholder="Confirm Password"
                value={passwordReset.confirmPassword}
                onChange={(e) => setPasswordReset({ ...passwordReset, confirmPassword: e.target.value })}
                className="w-full p-2 border border-blue-300 focus:border-blue-500 focus:ring-blue-500 rounded bg-white text-black placeholder-gray-500"
                required
              />

            
                <div className="flex justify-end gap-2">
                  <button
                    type="button"
                    onClick={() => {
                      setforgotPasswordtatusModal(false);
                      setPasswordReset({ ...passwordReset, emailId: '', password: '', confirmPassword: '',  notificationType: '' }) 
                      setCaptchaInput('')
                      setCaptchaValidation(false)
                    }}
                    className="px-4 py-2 border border-blue-300 text-blue-800 rounded hover:bg-blue-100"
                  >
                    Cancel
                  </button>
                  <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}


{listFixturesModal && (
                           <div className="fixed inset-0 z-100 bg-black/50 flex items-center justify-center">
  <div
    className="bg-blue-50 text-black rounded-lg p-6 w-full max-w-md shadow-lg absolute"
    style={{
      top: "150px",    // fixed distance from top
      left: "50%",     // center horizontally
      transform: "translateX(-50%)",
    }}
  >
                             <h2 className="text-xl font-bold mb-4 text-blue-800">View Fixtures</h2>
                             <form
                               className="space-y-4"
                             >
               <div className="space-y-2">
                
                 <div className="flex gap-2">
                   <ul className="list-disc list-inside text-gray-800">
                       {allFixtures.map((fixture, index) => (
                         <li key={index} ><span className="highlight-match">Match Number</span>: {fixture.matchId} {fixture.teamA} vs {fixture.teamB} | <span className="highlight-match">StartAt</span>: {fixture.startDate} | Status: {fixture.matchStatus} | Winner: {fixture.winner} | <span className="highlight-match">ImpactPlayer</span>: {fixture.playerOfTheMatch}</li>
                       ))}
                     </ul>
                 </div>
               </div>
                             
                               <div className="flex justify-end gap-2">
                                 <button
                                   type="button"
                                   onClick={() => setListFixturesModal(false)}
                                   className="px-4 py-2 border border-blue-300 text-blue-800 rounded hover:bg-blue-100"
                                 >
                                   Close
                                 </button>
                               </div>
                             </form>
                           </div>
                         </div>
              )}


{listLeaderModal && (
                           <div className="fixed inset-0 z-100 bg-black/50 flex items-center justify-center">
                           <div className="bg-blue-50 text-black rounded-lg p-6 w-full max-w-2xl shadow-lg">
                             <h2 className="text-xl font-bold mb-4 text-blue-800">Leader Board</h2>
                             <form
                               className="space-y-4"
                             >
               <div className="space-y-2">
                
                 <div className="flex gap-2">
            
               
                   <ul className="list-disc list-inside text-gray-800">

                    {listLeadersData !== null && listLeadersData.length > 0 ? (
                  <div>
                  {listLeadersData.map((teamStat, index) => (
                         <li key={index} ><span className="highlight-match">Team:</span>  {teamStat.teamName} | <span className="highlight-match"> Wins: </span>{teamStat.wins}</li>
                       ))}

                     </div>
                    ) : (
                 <p>No leaders yet</p>
                    )}

                     </ul>
   
                 </div>
               </div>
                             
                               <div className="flex justify-end gap-2">
                                 <button
                                   type="button"
                                   onClick={() => setListLeaderModal(false)}
                                   className="px-4 py-2 border border-blue-300 text-blue-800 rounded hover:bg-blue-100"
                                 >
                                   Close
                                 </button>
                               </div>
                             </form>
                           </div>
                         </div>
              )}


{showTeamDetailsModal && (
          <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center">
            <div className="bg-blue-50 text-black rounded-lg p-6 w-full max-w-md shadow-lg">
              <h2 className="text-xl font-bold mb-4 text-blue-800">Team Details</h2>
              <form
                className="space-y-4"
              >
<div className="space-y-2">
  <div className="flex gap-2">
    <label className="font-semibold">Team Name:</label>
    <span>{teamDetails.team.name}</span>
  </div>
  <div className="flex gap-2">
    <label className="font-semibold">Contact No:</label>
    <span>{teamDetails.team.contactNo}</span>
  </div>
  <div className="flex gap-2">
    <label className="font-semibold">Players:</label>
    <ul className="list-disc list-inside text-gray-800">
        {teamDetails.teamPlayer.map((player, index) => (
          <li key={index}>Player Name: {player.name} | Score: {player.playerScore}</li>
        ))}
      </ul>
  </div>
</div>
              
                <div className="flex justify-end gap-2">
                  <button
                    type="button"
                    onClick={() => setShowTeamDetailsModal(false)}
                    className="px-4 py-2 border border-blue-300 text-blue-800 rounded hover:bg-blue-100"
                  >
                    Close
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

            {showTeamPlayerModal && (
 <div className="fixed inset-0 z-50 bg-black/50">
 <div
    className="bg-blue-50 text-black rounded-lg p-6 w-full max-w-md shadow-lg absolute"
    style={{
      top: "270px",    // fixed distance from top
      left: "50%",     // center horizontally
      transform: "translateX(-50%)",
    }}
  >
              <h2 className="text-xl font-bold mb-4 text-blue-800">Add Players To The Team</h2>
            
              <form
                onSubmit={async (e) => {
                  e.preventDefault();
                  try {
                
                    const token = localStorage.getItem('token');
                    const res = await fetch(`${apiUrl}/teams/player`, {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json', 'Authorization':  `Bearer ${token}` },
                      body: JSON.stringify(newTeamPlayer),
                    });
                    if (res.ok) {
                      toast.success('Players updated successfully!');
                      setNewTeamPlayer({ name: '', tournamentId: '', teamId: '' });
                      setShowTeamPlayerModal(false);
                    } else {
                      toast.error('Failed to create player');
                    }
                  } catch (err) {
                    toast.error('Error occurred while managing player');
                    console.error(err);
                  }
                }}
                className="space-y-4"
              >
                <input
                  type="text"
                  placeholder="Player Name"
                  value={newTeamPlayer.name}
                  onChange={(e) => setNewTeamPlayer({ ...newTeamPlayer, name: e.target.value })}
                  className="w-full p-2 border border-blue-300 focus:border-blue-500 focus:ring-blue-500 rounded bg-white text-black placeholder-gray-500"
                  required
                />
                <select
                  value={newTeamPlayer.tournamentId}
                  onChange={(e) => {
                    setNewTeamPlayer({ ...newTeamPlayer, tournamentId: e.target.value })
                    const tournamentId = e.target.value;
            
                     handleViewTournaments(tournamentId);
                  }}
                  className="w-full p-2 border border-blue-300 focus:border-blue-500 focus:ring-blue-500 rounded bg-white text-black"
                  required
                >
                  <option value="">Select Tournament</option>
                  {userTournaments.map((t) => (
                    <option key={t.id} value={t.id}>{t.name}</option>
                  ))}
                </select>
                <select
                  value={newTeamPlayer.teamId}
                  onChange={(e) => setNewTeamPlayer({ ...newTeamPlayer, teamId: e.target.value })}
                  className="w-full p-2 border border-blue-300 focus:border-blue-500 focus:ring-blue-500 rounded bg-white text-black"
                  required
                >
                  <option value="">Select Team</option>
                  {tournamentTeams.map((t) => (
                    <option key={t.id} value={t.id}>{t.name}</option>
                  ))}
                </select>
                
                <div className="flex justify-end gap-2">
                  <button
                    type="button"
                    onClick={() => {
                      setShowTeamPlayerModal(false);
                      setNewTeamPlayer({ ...updateStatus, teamId: '', tournamentId: '', name: ''})
                    }}
                  
                    className="px-4 py-2 border border-blue-300 text-blue-800 rounded hover:bg-blue-100"
                  >
                    Cancel
                  </button>
                  <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
        
      </main>

      {!isSignedIn && (
        <div className="max-w-6xl mx-auto w-full px-6 md:px-8 mb-8 tems-center ">
          {allTournaments.length > 0 && (
            <div className="mt-8">
              <h3 className="text-center text-black-500  font-small font-style: italic text-xl md:text-2xl mx-auto">🏆 Upcoming Public Tournaments. Contact Organizer to register your team</h3>
              <ul className="space-y-3 grid sm:grid-cols-2 gap-4 mt-4">
                {allTournaments.map((t) => (
                  <li
                    key={t.id}
                    className="border border-blue-200 bg-blue-100 rounded p-3"
                  >
                    <p className="font-semibold">{t.name}</p>
                    <p className="text-sm text-black/70">📍 {t.location} | 📍 {t.area} | 📅 {t.date} | {t.area} | {t.sportName} | {t.tournamentStatus}</p>
                    <p> <span className="text-indigo-700 font-semibold">Venue:</span> {t.venue}</p>
                    <p> <span className="text-indigo-700 font-semibold">Winner:</span> {t.winner}</p>
                  </li>
                ))}
              </ul>
              <br></br>
            </div>
          )}
          
        </div>
      )}

{!isSignedIn && <section className="py-10 flex justify-center items-center">
  <div className="relative max-w-7xl w-full rounded-xl overflow-hidden">
    {/* Background video */}
    <video
      className="w-full h-auto object-cover rounded-xl"
      src="/videos/video66.mp4"
      autoPlay
      loop
      muted
      playsInline
    />

    {/* Overlay text */}
    <div className="absolute inset-0 flex flex-col items-center justify-center text-center text-white px-4">
      <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold">
        Discover Local Tournaments Near You
      </h2>
      <p className="text-sm sm:text-lg md:text-xl mt-2">
        Create events, manage teams, and grow your local sports community effortlessly.
      </p>
    </div>
  </div>
</section>}


{!isSignedIn &&<section className="py-10 flex justify-center items-center gap-6">
  
  <video
    className="max-w-7xl w-full h-auto object-cover rounded-xl"
    src="/videos/video77.mp4"
    autoPlay
    loop
    muted
    playsInline
  />
 
</section>}

{!isSignedIn &&<section className="py-10 flex justify-center items-center gap-6">
  
  <video
    className="max-w-7xl w-full h-auto object-cover rounded-xl"
    src="/videos/video88.mp4"
    autoPlay
    loop
    muted
    playsInline
  />
 
</section>}

{/* <section className="py-10 flex justify-center items-center gap-6">
  <video
    className="max-w-7xl w-full h-auto object-cover rounded-xl"
    src="/videos/video21.mp4"
    autoPlay
    loop
    muted
    playsInline
  />
</section> */}




{!isSignedIn && <section id="about" className="py-10 container mx-auto px-6">
      <div className="bg-gradient-to-r from-blue-100 via-blue-200 to-blue-200 p-6 rounded-xl shadow-lg max-w-8xl mx-auto my-8 text-center">
    <h2 className="text-xl sm:text-xl font-bold text-gray-800 mb-4 italic">
      🏟️ Playground Owners & Academy, Partner With Us!
    </h2>
    <p className="text-gray-700 text-center leading-relaxed">
      Are you a <span className="font-semibold">playground owner</span> or run a 
      <span className="font-semibold"> sports academy? </span>
      Partner with us to showcase your facilities and attract more players through our platform.
    </p>
    <p className="text-gray-700 mb-6">
      Unlock the power of digital bookings with{" "}
      <span className="font-semibold text-blue-600">LeagueSphere</span>.  
      Manage reservations effortlessly and let players book your playground slots
      anytime, anywhere.
    </p>
    <a
      href="mailto:contactleaguesphere@gmail.com"
      className="inline-block px-6 py-3 bg-yellow-500 text-white font-semibold rounded-xl shadow hover:bg-yellow-600 transition-transform transform hover:scale-105"
    >
      📩 Get Started — Contact Us
    </a>
    <p className="mt-4 text-sm text-gray-600">
      Reach us at{" "}
      <span className="font-semibold text-yellow-600">
        contactleaguesphere@gmail.com
      </span>{" "}
      to onboard your playground today.
    </p>
  </div>
</section>}

      {!isSignedIn && <AboutSection />}



    {!isSignedIn &&  < FeatureSection/>}

    {!isSignedIn && <OrganiserTeamSection/>}

{/* FAQ Section */}
{!isSignedIn && <FaqSection />}



{isSignedIn && userTournaments.length > 0 && (
              <div className="max-w-6xl mx-auto w-full px-6 md:px-8 mb-8 items-center">
                <h3 className="text-lg font-bold mb-3 text-blue-800 text-center">Your Tournaments</h3>
                <ul>
                  {userTournaments.map((t) => (
                    <li  style={{ marginBottom: '10px' }}
                      key={t.id}
                      onClick={() => handleViewTournament(t)}
                      className="cursor-pointer border border-blue-200 bg-blue-100 rounded p-3 hover:bg-blue-200 transition"
                    >
                      <p className="font-semibold">{t.name}</p>
                      <p className="text-sm text-black/70">📍 {t.location} | 📍 {t.area} | 📅 {t.date} | {t.area} | {t.sportName} | {t.tournamentStatus}</p>
                      <p> <span className="text-indigo-700 font-semibold">Venue:</span> {t.venue}</p>
                      <p> <span className="text-indigo-700 font-semibold">Winner:</span> {t.winner}</p>
                      <p> <span className="text-indigo-700 font-semibold">Player of the tournament:</span> {t.playerOfTheTournament}</p>
                    </li>
                  ))}
                </ul>
              </div>
            )}


<footer className="text-sm text-white py-10 bg-blue-900 shadow-lg">
  {/* Promotional CTA for Organizers */}
  <div className="px-4 mb-8">
    <div className="max-w-4xl mx-auto bg-white/10 p-6 rounded-2xl shadow text-center">
      <h4 className="text-lg font-semibold mb-2 italic">Promote Your Academy or Tournament</h4>
      <p className="text-sm text-pink-100 mb-4 italic">
        Want to highlight your sports brand or local tournament on our platform?
      </p>
      <a
        href="mailto:contactleaguesphere@gmail.com?subject=Promote%20with%20LeagueSphere"
        className="inline-block px-5 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg shadow-md transition"
      >
        Promote with Us
      </a>
    </div>
  </div>

  {/* Footer Content */}
  <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-8 px-6">
    
    {/* Left Section - Logo + Email */}
    <div className="text-center md:text-left space-y-2">
      <div className="flex items-center justify-center md:justify-start gap-2">
        <img src="/image1.png" alt="Logo" className="h-8 w-8 rounded-full shadow" />
        <span className="font-semibold text-white text-lg italic tracking-wide">LeagueSphere</span>
      </div>
      <p className="text-xs text-pink-100 italic">📧 contactleaguesphere@gmail.com</p>
    </div>

    {/* Center Section - YouTube */}
    <div className="text-center">
          <a
            href="https://www.youtube.com/@LeagueSphere"
            target="_blank"
            rel="noopener noreferrer"
            className="flex flex-col items-center hover:text-red-400 transition-colors"
          >
            <FaYoutube size={32} color="red"  className="mb-1" /> {/* YouTube Icon */}
            <span className="font-semibold text-lg">YouTube</span>
            <span className="text-sm">Watch our videos</span>
          </a>
        </div>


   {/* Center Section - Instagram */}
<div className="text-center mt-4">
  <a
    href="https://www.instagram.com/LeagueSphere"
    target="_blank"
    rel="noopener noreferrer"
    className="flex flex-col items-center hover:text-pink-500 transition-colors"
  >
    <FaInstagram size={32} color="#C13584" className="mb-1" /> {/* Instagram Icon */}
    <span className="font-semibold text-lg">Instagram</span>
    <span className="text-sm">Follow us for updates</span>
  </a>
</div>
    {/* Right Section - Links + Copyright */}
    <div className="text-center md:text-right space-y-3">
      <div className="space-x-5 font-medium">
        <a href="/about" className="hover:text-pink-300">About Us</a>
        <a href="/terms" className="hover:text-pink-300">Terms</a>
        <a href="/privacy" className="hover:text-pink-300">Privacy</a>
      </div>
     
    </div>
  </div>
</footer>

      <ToastContainer />
    </div>
  );
};

export default App;